export default __webpack_public_path__ + "static/media/disc.d1d1d4d1.svg";